import React, { Component } from 'react'
import { connect } from 'react-redux'

import RestaurantForm from '../../forms/restaurantForm/RestaurantForm'
import fetchRestaurantAvailabilityBegin, { resetRestaurantAvailability } from '../../../actions/fetchRestaurantAvailability'
import setActiveRestaurants from '../../../actions/setActiveRestaurants'
import removeActiveRestaurants from '../../../actions/removeActiveRestaurants'

import _ from 'lodash'
import moment from 'moment'

import placeholderImage from '../../../assets/images/placeholder-image.png'

class BkFlowRestaurantsCard extends Component  {
	constructor(props) {
		super(props)

		const { urlData } = props

		// Initialize default time
		let defaultDate = moment(new Date(), 'MM-DD-YYYY'),
				defaultTime = '17:00',
				defaultParty = '2'

		if (
			urlData &&
			urlData.startDate
		) {
			defaultDate = moment(urlData.startDate)
		}

		// Override default time using ENV variables
		if (process.env.REACT_APP_COMPONENT_RESTAURANT_DEFAULT_TIME) {
			defaultTime = process.env.REACT_APP_COMPONENT_RESTAURANT_DEFAULT_TIME
		}
		if (process.env.REACT_APP_COMPONENT_RESTAURANT_DEFAULT_PARTY) {
			defaultParty = process.env.REACT_APP_COMPONENT_RESTAURANT_DEFAULT_PARTY
		}

		this.state = {
			restaurantToggled: false,
			reservationTime: defaultTime,
			reservationParty: defaultParty,
			reservationDate: defaultDate,
			focused: false,
			activeReservationTime: null,
		}
	}

	handleReservationTime = (reservationTime, reservationType) => {
		this.setState({
			activeReservationTime: reservationTime,
			reservationType: reservationType
		})
	}

	render() {
		const {
			configData,
			activeStep,
			restaurantCardType,
			restaurantKey,
			restaurantAvailabilityData,
			activeRestaurantsData,
			handleFetchRestaurantAvailability,
			handleBackToSearch,
			handleSetActiveRestaurant,
			handleRemoveActiveRestaurant,
			handleContinuePayment,
		} = this.props

		const hotelLabels = configData.hotel.labels[0]
		const restaurantDetailsData = restaurantCardType[restaurantKey].serviceDetails.comments

		// Loop and uniquely key restaurant details
		let keyedDetails = {},
				enableSetActiveReservation = false,
				isActiveReservation = false,
				activeReservation = null

		for (const detailKey in restaurantDetailsData) {
			keyedDetails[restaurantDetailsData[detailKey].name.toLowerCase()] = restaurantDetailsData[detailKey]
		}

		Object.keys(activeRestaurantsData).forEach(restaurant => {
			if (restaurant === restaurantCardType[restaurantKey].id) {
				isActiveReservation = true
				activeReservation = activeRestaurantsData[restaurantCardType[restaurantKey].id]
			}
		})

		// Set restaurantMapLink Google link features
		const restaurantGoogleTarget = 'targetWindow',
					restaurantGoogleFeatures = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=800'

		let restaurantMapLink = null

		if (!_.isEmpty(keyedDetails)) {
			// Set restaurantMapLink if data criteria is met
			if (
				keyedDetails.title &&
				keyedDetails.title.text &&
				keyedDetails.cityname &&
				keyedDetails.cityname.text &&
				keyedDetails.postalcode &&
				keyedDetails.postalcode.text &&
				keyedDetails.address &&
				keyedDetails.address.text
			) {
				const restaurantGoogleDomain = 'http://maps.google.com/?q=',
							restaurantMapAddress = keyedDetails.title.text + ', ' + keyedDetails.address.text + ', ' + keyedDetails.cityname.text + ', ' + keyedDetails.postalcode.text

				// Construct dynamic link for restaurant location based on seven rooms data
				restaurantMapLink = String(restaurantGoogleDomain + restaurantMapAddress)
			}

			// Use placeholder brand image or set from Seven room feed
			let restaurantImageSrc = placeholderImage

			if (
				keyedDetails.image &&
				keyedDetails.image.image
			) {
				restaurantImageSrc = keyedDetails.image.image
			}

			if (
				restaurantCardType[restaurantKey].id &&
				this.state.reservationDate &&
				this.state.activeReservationTime &&
				this.state.reservationParty
			) {
				enableSetActiveReservation = true
			}

			return (
				<div
					className="bk-flow-restaurants__card"
					key={restaurantCardType[restaurantKey].id}
				>

					<div
						className="bk-flow-restaurants__card-image u-bg-image"
						style={{ backgroundImage: 'url(' + restaurantImageSrc + ')' }}
					>
						<img
							className="u-element-hidden"
							src={ restaurantImageSrc }
							alt="Coming Soon"
						/>
					</div>

					<div className="bk-flow-restaurants__card-data">
						{ keyedDetails.title && keyedDetails.title.text &&
						<h4>{ keyedDetails.title.text }</h4>
						}

						{ keyedDetails.phonenumber && keyedDetails.phonenumber.text &&
							<a href={'tel:' + keyedDetails.phonenumber.text}>{keyedDetails.phonenumber.text}</a>
						}

						{ keyedDetails.address && keyedDetails.address.text &&
							<p className="u-remove-margin">{ keyedDetails.address.text }</p>
						}

						{ keyedDetails.cityname && keyedDetails.cityname.text &&
						<p className="u-remove-margin">{ keyedDetails.cityname.text }</p>
						}

						{ keyedDetails.postalcode && keyedDetails.postalcode.text &&
						<p className="u-remove-margin">{ keyedDetails.postalcode.text }</p>
						}

						{ restaurantMapLink &&
							<button
								className="bk-flow-restaurants__card-map-link btn btn-text-only"
								onClick={() => window.open(
									restaurantMapLink,
									restaurantGoogleTarget,
									restaurantGoogleFeatures
								)}
							>
								{ hotelLabels && hotelLabels.viewMap ? hotelLabels.viewMap : 'View map' }
							</button>
						}
					</div>

					<div className="bk-flow-restaurants__card-reserve-toggle">
						<button
							className="btn btn-transparent"
							onClick={ () => this.setState({ restaurantToggled: !this.state.restaurantToggled }) }
						>
							{ hotelLabels && hotelLabels.reserve ? hotelLabels.reserve : 'Reserve' }
						</button>
					</div>

					<RestaurantForm
						configData={ configData }
						activeStep={ activeStep }
						isActiveReservation={ isActiveReservation }
						activeReservation={ activeReservation }
						restaurantVenueId={ restaurantCardType[restaurantKey].id }
						restaurantKey={ restaurantKey }
						restaurantToggled={ this.state.restaurantToggled }
						handleBackToSearch={ () => handleBackToSearch(restaurantCardType[restaurantKey].id)}
						handleClose={ () => this.setState({ restaurantToggled: false }) }
						reservationTime={ this.state.reservationTime }
						handleReservationTime={ (time) => this.setState({ reservationTime: time })}
						reservationParty={ this.state.reservationParty }
						handleReservationParty={ (party) => this.setState({ reservationParty: party })}
						reservationDate={ this.state.reservationDate }
						reservationDateFocused={ this.state.focused }
						handleReservationDate={ (date) => this.setState({ reservationDate: date })}
						handleReservationDateFocus={ ({ focused }) => this.setState({ focused }) }
						restaurantAvailabilityData={ restaurantAvailabilityData }
						handleFetchRestaurantAvailability={ handleFetchRestaurantAvailability }
						activeReservationTime={ this.state.activeReservationTime }
						handleActiveReservationTime={ (activeTime, activeType) => this.handleReservationTime(activeTime, activeType)}
						handleSetActiveRestaurant={
							enableSetActiveReservation ?
								() => handleSetActiveRestaurant(
									restaurantCardType[restaurantKey].id,
									this.state.reservationDate,
									this.state.activeReservationTime,
									this.state.reservationType,
									this.state.reservationParty,
									keyedDetails,
								)
							:
								null
						}
						handleRemoveActiveRestaurant={ () => handleRemoveActiveRestaurant(restaurantCardType[restaurantKey].id)}
						handleContinuePayment={ handleContinuePayment }
					/>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		urlData: state.availabilityData.urlData,
		activeRestaurantsData: state.activeRestaurantsData,
		restaurantAvailabilityData: state.restaurantAvailabilityData,
	}
}

const mapDispatchToProps = dispatch => ({
	handleFetchRestaurantAvailability(venueId, reservationDate, reservationStartTime, party, restaurantData) {
		return dispatch(fetchRestaurantAvailabilityBegin(venueId, reservationDate, reservationStartTime, party, restaurantData))
	},
	handleBackToSearch(venueId) {
		return dispatch(resetRestaurantAvailability(venueId))
	},
	handleSetActiveRestaurant(venueId, reservationDate, reservationTime, party, venueData) {
		return dispatch(setActiveRestaurants(venueId, reservationDate, reservationTime, party, venueData))
	},
	handleRemoveActiveRestaurant(activeVenueId) {
		return dispatch(removeActiveRestaurants(activeVenueId))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowRestaurantsCard)



// WEBPACK FOOTER //
// ./src/components/restaurants/elements/BkFlowRestaurantsCard.js